import { apiFetch, readErrorMessage } from '../api/client';
import { mountApiBase, previewFileUrl } from '../fileBrowser/fileBrowserApi';
import { jdocAssetsFolderForPath } from './docTypes';

export async function uploadJdocAsset(
  mountId: string,
  docPath: string,
  file: File
): Promise<{ relativePath: string; previewUrl: string }> {
  const assetsFolder = jdocAssetsFolderForPath(docPath);
  const form = new FormData();
  form.append('file', file, file.name);

  const res = await apiFetch(`${mountApiBase(mountId)}/upload?path=${encodeURIComponent(assetsFolder)}`, {
    method: 'POST',
    body: form
  });

  if (!res.ok) {
    throw new Error(await readErrorMessage(res));
  }

  const relativePath = `${assetsFolder}/${file.name}`;
  return {
    relativePath,
    previewUrl: previewFileUrl(mountId, relativePath)
  };
}
